// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"40":"cookie-policy","786":"sign-up","959":"calculator","966":"login"}[chunkId] + "." + {"40":"e3804875","786":"0fc80b99","959":"9fa23e14","966":"0370275f"}[chunkId] + ".chunk.css";
};